export const globalVars = {
  pagesPaths: {
    login: "/app/login",
    support: "/support",
  },
  $eles: {
    $navMenu: "[ss-navbar-comp-ele='nav-menu']",
    $btnsHolder: "[ss-btn-group='holder']",
    $paginationList: "[ss-pagination-ele='list-holder']",
    $paginationListItem: "[ss-pagination-ele='item-card']",
    $paginationItemCardDate: "[pagination-item-card='date']",
    $paginationItemCardMonth: "[pagination-item-card='month']",
    $paginationItemCardHeute: "[pagination-item-card='heute']",
    $exerciseListHolder: "[ss-exercise-comp='list-holder']",
    $exerciseCard: "[ss-exercise-comp='card']",
    $exerciseTabsListHolder: "[ss-exercise-comp-ele='exercise-tabs-holder']",
    $exerciseTabEle: "[ss-exercise-comp-ele='exercise-tab']",
    $exerciseTabContentList: "[ss-exercise-comp-ele='tabs-content-list']",
    $exerciseTabContentCard: "[ss-exercise-comp-ele='tab-content-card']",
    exerciseCard: {
      $dayIndex: "[ss-var-update-ele='date']",
    },
    exerciseTabEle: {
      $typeOfExercise: "[exercise-tab-ele='type-of-exercise']",
      $exerciseName: "[exercise-tab-ele='exercise-name']",
      $exerciseTime: "[exercise-tab-ele='exercise-time']",
    },
    exerciseTabContentCard: {
      $respSubmittedBlock:
        "[exercise-tab-content-card-ele='response-submitted']",
      $exerciseName: "[exercise-tab-content-card-ele='exercise-name']",
      $exerciseTime: "[exercise-tab-content-card-ele='exercise-time']",
      $exerciseType: "[exercise-tab-content-card-ele='exercise-type']",
      $exerciseDefaultRepsEle: "[exercise-tab-content-card-ele='default-reps']",
      $exerciseHasRepsEle: "[exercise-tab-content-card-ele='has-reps']",
      $exerciseHasRepsEleTxt: "[exercise-tab-content-card-ele='reps-txt']",
      $exerciseDesc: "[exercise-tab-content-card-ele='exercise-desc']",
      $exerciseVideo: "[exercise-tab-content-card-ele='exercise-video']",
      $exerciseCompletedBtn:
        "[exercise-tab-content-card-ele='exercise-completed-btn']",
      $exerciseSkippedBtn:
        "[exercise-tab-content-card-ele='exercise-skipped-btn']",
    },
    food: {
      $foodListHolder: "[ss-food-comp='list-holder']",
      $foodCard: "[ss-food-comp='card']",
      $foodTabsListHolder: "[ss-food-comp-ele='food-tabs-holder']",
      $foodTabEle: "[ss-food-comp-ele='food-tab']",
      $foodTabContentList: "[ss-food-comp-ele='tabs-content-list']",
      $foodTabContentCard: "[ss-food-comp-ele='tab-content-card']",
      foodCard: {
        $foodQuantity: "[food-tab-ele='food-quantity']",
        $foodName: "[food-tab-ele='food-name']",
      },
      foodContentCard: {
        $foodName: "[food-tab-content-card-ele='food-name']",
        $foodQuantity: "[food-tab-content-card-ele='food-quantity']",
        $foodDesc: "[food-tab-content-card-ele='food-desc']",
        $foodDescVanilla: "[food-tab-content-card-ele='food-desc-vanilla']",
        $foodDescNeutral: "[food-tab-content-card-ele='food-desc-neutral']",
        $foodImg: "[food-tab-content-card-ele='food-img']",
        $foodCompletedBtn: "[food-tab-content-card-ele='food-completed-btn']",
        $respSubmittedBlock: "[food-tab-content-card-ele='response-submitted']",
      },
    },
    $loadingScreen: "[ss-loading-screen]",
  },
  attr: {
    dateOfOperation: "[ss-var-operation-date]",
    activeClass: "ss-var-active-class",
    dayTabIndex: "ss-var-day-tab-index",
    logicConditionEle: "ss-logic-condition-ele",
    exerciseTabIndex: "ss-var-exercise-tab-index",
    foodTabIndex: "ss-var-food-tab-index",
    morningExerciseTab: "ss-var-morning-exercise-tab",
    eveningExerciseTab: "ss-var-evening-exercise-tab",
    uniExerciseTabAttr: "ss-var-exercise-uni-tab-index",
    heuteActiveTab: "ss-var-heute-active-tab",
  },
  LSKeys: {
    userData: "ss-user-data",
    userSyncData: "ss-user-sync-data",
    userToken: "token",
    userPageSlug: "userPageSlug",
  },
  mainTabs: {
    $ele: "[ss-main-tabs='list-holder']",
    $tabItemAttr: "ss-main-tab-item",
    $bodyAttr: "ss-main-tab-active",
    items: {
      fitnessPlan: "fitness-plan",
      foodPlan: "food-plan",
    },
    $logoutBtn: "[ss-setting-tab-item='logout']",
  },
  classes: {
    active: "is-active",
    hide: "hide",
    completed: "is-completed",
  },
  events: {
    userLoaded: "ssUserLoaded",
    userSyncDataLoaded: "ssUserSyncDataLoaded",
    userSyncDataUpdated: "ssUserSyncDataUpdated",
  },
  reactionEles: {
    todoStateHolder: {
      $ele: "[ss-tab-reaction-ele='todo-state']",
      isCompleted: "is-completed",
      isSkipped: "is-skipped",
    },
  },
  taskStates: {
    completed: "is-completed",
    skipped: "is-skipped",
    dayTabsCompleted: "day-tabs-completed",
    eveningTabsCompleted: "evening-tabs-completed",
    foodTabsCompleted: "food-tabs-completed",
  },
  actionEles: {
    dayNightTabHolder: {
      $ele: "[ss-action-btns='day-night']",
      tabElesAttr: "ss-day-night-btn",
      $dayTab: "[ss-day-night-btn='day']",
      $nightTab: "[ss-day-night-btn='night']",
      exerciseTimeAttr: "ss-exercise-time",
    },
  },
  iconEles: {
    tickIcon: "[ss-custom-icon='tick']",
  },
  texts: {
    pleaseWait: "Bitte warten...",
  },
};